export const SCORE_FIELDS = [
  { key: "fun", label: "Divertido", hint: "Leveza e senso de aventura", color: "blue" },
  {
    key: "trustworthy",
    label: "Confiável",
    hint: "Transmite confiança e honestidade",
    color: "gold",
  },
  { key: "attractive", label: "Atraente", hint: "Aparência geral e estilo", color: "green" },
] as const;

export type ScoreKey = (typeof SCORE_FIELDS)[number]["key"];
export type ScoreMap = Record<ScoreKey, number>;

export const DEFAULT_SCORES: ScoreMap = Object.fromEntries(
  SCORE_FIELDS.map((f) => [f.key, -1])
) as ScoreMap;

export const SCORE_LABELS: Record<string, string> = Object.fromEntries(
  SCORE_FIELDS.map((f) => [f.key, f.label])
);

export const SCORE_SCALE = [
  { value: 3, label: "Muito" },
  { value: 2, label: "Sim" },
  { value: 1, label: "Um pouco" },
  { value: 0, label: "Não" },
] as const;

export const AGE_RANGES = [
  { label: "18-24", minAge: 18, maxAge: 24 },
  { label: "25-34", minAge: 25, maxAge: 34 },
  { label: "35-44", minAge: 35, maxAge: 44 },
  { label: "45-54", minAge: 45, maxAge: 54 },
  { label: "55-64", minAge: 55, maxAge: 64 },
  { label: "65+", minAge: 65, maxAge: 150 },
] as const;

export const VOTE_TARGET_OPTIONS = [10, 25, 50, 100, 200] as const;

export const GENDER_OPTIONS = [
  { value: "male", label: "Masculino" },
  { value: "female", label: "Feminino" },
] as const;

export const DEMOGRAPHIC_GENDER_OPTIONS = [
  { value: "any", label: "Qualquer" },
  { value: "male", label: "Apenas masculino" },
  { value: "female", label: "Apenas feminino" },
] as const;

export type Category = "dating" | "social" | "business";

export const CATEGORIES: { value: Category; label: string; description: string }[] = [
  { value: "dating", label: "Encontros", description: "Primeiras impressões para encontros" },
  { value: "social", label: "Social", description: "Contextos sociais em geral" },
  { value: "business", label: "Profissional", description: "Networking e ambiente profissional" },
];

export const AGE_CONSTRAINTS = {
  min: 18,
  max: 120,
} as const;
